<template>
  <div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="成交额" name="first">
      <!-- <div class="cloumnEchart" ref="cloumnRef"></div> -->
    </el-tab-pane>
    <el-tab-pane label="成交人数" name="second"></el-tab-pane>
    <el-tab-pane label="成交次数" name="third"></el-tab-pane>
   
  </el-tabs>
    <div class="cloumnEchart" ref="cloumnRef"></div>
  </div>
</template>

<script>
import { mapActions,mapState} from "vuex";

export default {
    props:['startTime','endTime','type','symbol'],
  data() {
    return {
      activeName: 'first',
      activeType:''
    };
  },
  computed: {
    ...mapState('report',['columnData']),
    filterList(){
      if(this.activeName=='first'){
        console.log(1111111111);
        return this.columnData.map(item=>{return item.totalLimit})
      }
      if(this.activeName=='second'){
        console.log(22222222);
        return this.columnData.map(item=>{return item.totalUserNumber})
      }
      if(this.activeName=='third'){
        console.log(33333333);
        return this.columnData.map(item=>{return item.totalNumber})
      }

    }
  },
  methods: {
    ...mapActions("report", ["getColumnData"]),
    handleClick(tab, event) {
        // console.log(tab.label, event);
      },
    showCloumnData() {
      const mychart = this.$echarts.init(this.$refs.cloumnRef);
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: "category",
          // axisLine: { show: false }, //隐藏x轴线
          // axisTick: { show: false }, //隐藏x轴刻度
          axisTick: {
            alignWithLabel: true
          },
          data: this.columnData.map(item=>{return item.coinType}),
        },
        color: ["#5470c6"],
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: this.filterList,
            // data: [ 120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110, 130],
            type: "bar",
            barWidth: '60%',
            name: '数量',
          },
        ],
      };
      mychart.setOption(option);
      window.addEventListener("resize", () => {
        mychart.resize();
      });
    },
  },
  mounted() {
    this.getColumnData({
      endTime: 0,
      startTime: 0,
      symbol: "",
      type: 0,
    }).then(res=>{
      console.log('res-column',res);
    })
    this.showCloumnData();
  },
  watch: {
    startTime:{
        handler(val,oldVal){

            if(val){
                this.getColumnData({
                    endTime: this.endTime ,
                    startTime: val,
                    symbol: this.symbol,
                    type: this.type
                }).then(res=>{
                    console.log('start-res',res);
                    this.showCloumnData()
                })
            }
        },
        immediate:true,
        deep:true
      },
      symbol:{
        handler(val,oldVal){

            if(val){
                this.getColumnData({
                    endTime: this.end ,
                    startTime: this.startTime,
                    symbol: val,
                    type: this.type
                }).then(res=>{
                    console.log('start-res',res);
                    this.showCloumnData()
                })
            }
        },
        immediate:true,
        deep:true
      },
      
      activeName:{
        handler(val,oldVal){

          console.log('activeName',val,oldVal);
          console.log('list--------',this.filterList);
          this.showCloumnData()
          // if(val=='first'){
          //   this.showCloumnData('totolLimit')
          // }else if(val=='second'){
          //   this.showCloumnData('totalUserNumber')
          // }else{
          //   this.showCloumnData('totalNumber')
          // }
            // if(val){
            //     this.getColumnData({
            //         endTime: this.end ,
            //         startTime: this.start,
            //         symbol: this.symbol,
            //         type: this.type
            //     }).then(res=>{
            //         console.log('end-res',res);
            //         this.showCloumnData()
            //     })
            // }
        },
        immediate:true,
        deep:true
      },  
  }
};
</script>

<style lang="less" scoped>
.cloumnEchart {
  width: 100%;
  height: 400px;
  box-sizing: border-box;
}
</style>
